import { environment } from '../../../environments/environment';

/** Site origin with no trailing slash, e.g. "https://rewire.tatamotors.com". */
export const SITE_ORIGIN = environment.baseUrl.replace(/\/+$/, '');

export const SITE_NAME = 'RE.WI.RE – A Tata Motors Initiative';
export const LEGAL_NAME = 'Tata Motors Limited';

export const DEFAULT_DESCRIPTION =
  'Scrap your old vehicle online with Tata Motors RE.WI.RE, a Registered Vehicle Scrapping ' +
  'Facility. Get the best price for your end-of-life vehicle with 100% free doorstep ' +
  'inspection and a Certificate of Deposit.';

/** 1200x630 social card. Relative to the site root. */
export const DEFAULT_OG_IMAGE = '/assets/images/og-rewire.jpg';
export const LOGO_PATH = '/assets/images/logos/Rewire_Blue_Logo_Name.svg';

export const TOLL_FREE = '+91-1800-268-8787';
export const SOCIAL_PROFILES = [
  'https://www.instagram.com/tatamotors.re.wi.re/',
  'https://www.youtube.com/user/TataMotorsGroup',
  'https://www.linkedin.com/company/tata-motors/',
];

/** Absolute URL for a site path or an already-absolute URL. */
export function absoluteUrl(pathOrUrl: string | null | undefined): string {
  if (!pathOrUrl) { return SITE_ORIGIN + '/'; }
  if (/^https?:\/\//i.test(pathOrUrl)) { return pathOrUrl; }
  return SITE_ORIGIN + (pathOrUrl.startsWith('/') ? '' : '/') + pathOrUrl;
}

/** Canonical form of a router URL: no query, no fragment, no trailing slash (except "/"). */
export function canonicalPath(url: string | null | undefined): string {
  let path = (url || '/').split(/[?#]/)[0] || '/';
  if (path.length > 1) { path = path.replace(/\/+$/, ''); }
  return path || '/';
}
